import cssUtil from 'gw-portals-util-js/CssUtil';

import templateStr from 'text!./input-inline-button.html';
import styles from './input-inline-button-hashed.scss';
import _ from 'lodash';

var hashedTemplate = cssUtil.hashTemplate(templateStr, styles);

export default [function () {
    return {
        restrict: 'EA',
        template: hashedTemplate,
        transclude: true,
        scope: {
            'showNestedButton': '=',
            'buttonLabel': '@',
            'onClick': '='
        },
        controller: function controller($scope) {
            $scope.onClick = $scope.onClick || _.noop();
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/platform/widgets/inputs/input-inline-button/input-inline-button.js
// module id = 783
// module chunks = 0